<template>
  <billing-dialog
    class="video-management-plan-details"
    v-model="visible"
    :title="title"
    @close="handleCancel"
    @back-event="handleCancel">
    <price-list
      class="video-management-plan-details__price-list"
      :showDecimalPoint="is_desktop_reactive"
      :plan-category="planCategory"
      :unit-type="planUnitMap.license"
    />
    <ul class="video-management-plan-details__desc">
      <li v-for="item in descList" :key="item">
        <span>{{ item }}</span>
      </li>
    </ul>
  </billing-dialog>
</template>

<script>
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import PriceList from '@/components/price-list.vue';
import { planUnitMap } from '@/common/product-unit';
import BillingDialog from '@/components/billing-dialog.vue';

export default {
  name: 'VideoManagementPlanDetails',
  mixins: [ConfirmComponent],
  components: {
    PriceList,
    BillingDialog
  },
  props: {
    title: String,
    planCategory: String,
    trackingPlanName: String,
  },
  data() {
    return {
      visible: false,
      planUnitMap,
      descList: [
        this.$t('billing.video_management.features_item1'),
        this.$t('billing.video_management.features_item2'),
        this.$t('billing.video_management.features_item3'),
      ],
    };
  },
  watch: {
    /**
     * watch visible and fire event
     * @param {boolean} val visible
     */
    visible(val) {
      this.$tracking.buyInteraction('plan details', `${this.trackingPlanName} plan details - ${val ? 'impression' : 'exit'}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@zoom/billing-responsive/styles/responsive.scss';
.video-management-plan-details {
  :deep(.zbo-dialog) {
    padding: 72px 60px;
    min-width: 576px;
    width: fit-content;
  }
  :deep(.zbo-dialog__header) {
    padding-bottom: 0;
  }
  &__title {
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    font-size: 22px;
    font-weight: 700;
    line-height: 1.5em;
  }

  &__price-list {
    margin-bottom: 4px;
    padding: 8px 0;
    @include media(mobile, tablet) {
      margin-top: 4px;
    }
  }

  &__desc {
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5em;
    margin-left: 15px;
    > li {
      list-style-image: url('@/assets/plans/check.svg');
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0;
      }
      span {
        position: relative;
        left: 4px;
      }
    }
  }
}
</style>
